/* eslint-disable import/order */
import { projectSettingsSoftwareIssuetypesWorkflowRoute } from '@jira/router-routes__project-settings-workflow-editor-software-routes/src/projectSettingsSoftwareIssuetypesWorkflowRoute.tsx';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { workflowBuilderProvisioningResource } from '@jira/router-resources__admin-pages-workflows-workflow-builder-provisioning/src/useWorkflowBuilderProvisioning.tsx';
import { workflowCapabilitiesResource } from '@jira/router-resources__admin-pages-workflows-workflow-capabilities/src/workflowCapabilitiesResource.tsx';
import { workflowDocumentResource } from '@jira/router-resources__admin-pages-workflows-workflow-document/src/workflowDocumentResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { jiraSpaResources } from '@jira/router-resources__spa-page-container/src/jiraSpaResources.tsx';
import { rovoEntitlementResource } from '@jira/router-resources__rovo-entitlement/src/useRovoEntitlementResource.tsx';
import { softwareProjectLayout } from '@jira/platform__layouts-software-project-layout/src/index.tsx';
import { chromelessLayout } from '@jira/platform__layouts-chromeless-layout/src/index.tsx';
import { expValEquals } from '@atlassian/jira-feature-experiments';
import { projectWorkflowContextResource } from '@jira/router-resources__project-workflow-context/src/projectWorkflowContextResource.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { LazyIssueTypeSettings } from '@jira/router-routes__project-settings-product-routes-software-entries/src/ui/project-settings/issue-type/index.tsx';
import { getSettingsNavigationResources } from '@jira/router-routes__project-settings-product-routes-software-entries/src/ui/project-settings/product-routes/common/index.tsx';
import WorkflowNavigationPage, {
	LazyWorkflowNavigationSettings,
} from '@jira/router-routes__project-settings-product-routes-software-entries/src/ui/project-settings/workflow-navigation/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

const getWorkflowBuilderProvisioningResources = () => [workflowBuilderProvisioningResource];

export const projectSettingsSoftwareIssuetypesWorkflowRouteEntry: Route = createEntry(
	projectSettingsSoftwareIssuetypesWorkflowRoute,
	() => ({
		group: 'project-settings-software',
		// eslint-disable-next-line no-restricted-syntax
		component: WorkflowNavigationPage,

		layout: expValEquals('hix-7127_wfe_layout_to_chromeless_for_software', 'isEnabled', true, false)
			? chromelessLayout
			: softwareProjectLayout,

		navigation: expValEquals(
			'hix-7127_wfe_layout_to_chromeless_for_software',
			'isEnabled',
			true,
			false,
		)
			? undefined
			: {
					menuId: MenuIdProjects,
					sidebarId: SidebarIdProjectSettings,
				},

		resources: expValEquals(
			'hix-7127_wfe_layout_to_chromeless_for_software',
			'isEnabled',
			true,
			false,
		)
			? [
					...jiraSpaResources(),
					// Delete this resource after hix-7127_wfe_layout_to_chromeless_for_software experiment is over
					// AND usages of projectContextResource have been swapped with projectWorkflowContextResource
					projectContextResource,
					projectWorkflowContextResource,
					workflowCapabilitiesResource,
					workflowDocumentResource,
					rovoEntitlementResource,
					...getWorkflowBuilderProvisioningResources(),
				]
			: [
					...jiraSpaResources(),
					...getSettingsNavigationResources(),
					...getWorkflowBuilderProvisioningResources(),
					workflowBuilderProvisioningResource,
				],

		forPaint: expValEquals(
			'hix-7127_wfe_layout_to_chromeless_for_software',
			'isEnabled',
			true,
			false,
		)
			? [LazyWorkflowNavigationSettings]
			: [LazyAtlassianNavigation, LazyIssueTypeSettings],

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@jira/router-routes__project-settings-workflow-editor-software-entries/src/projectSettingsSoftwareIssuetypesWorkflowRouteEntry.tsx',
				whichExportToUse: 'projectSettingsSoftwareIssuetypesWorkflowRouteEntry',
			},

			enabled: true,
		},
	}),
);
